import { ModalButton } from "@components/atoms";
import { DeleteOutlined } from "@ant-design/icons";
import { Row, Typography } from "antd";
import useDeleteVoucher from "./useDeleteVoucher";

const { Text } = Typography;

type DeleteVoucherModalProps = {
	ids: string[] | undefined;
	labelHasIcon?: boolean;
	navigateAfterDelete?: boolean;
	buttonType: "primary" | "default" | "link" | "text" | "ghost";
	cleanUp?: () => void;
};

const DeleteVoucherModal = ({
	ids,
	labelHasIcon,
	navigateAfterDelete,
	buttonType,
	cleanUp,
}: DeleteVoucherModalProps) => {
	const { buttons } = useDeleteVoucher({
		ids,
		navigateAfterDelete,
		cleanUp,
	});
	return (
		<ModalButton
			modalTitle={
				<Row justify="center">
					<Text>Delete Voucher</Text>
				</Row>
			}
			buttonLabel={
				labelHasIcon ? (
					<>
						<DeleteOutlined /> Delete
					</>
				) : (
					"Delete"
				)
			}
			buttons={buttons}
			dangerButton
			buttonType={buttonType}
		>
			<Row justify="center">
				<Text type="secondary">
					Are you sure you want to permanently delete this voucher?
				</Text>
			</Row>
		</ModalButton>
	);
};

export default DeleteVoucherModal;
